export * from "./nfe-consignacao-fechamento.component";
